
import { PropType, defineComponent } from "vue";
export default defineComponent({
  name: "customPanel",
  props: {
    title: {
      type: String as PropType<string>,
    },
  },
});
